import script from "./trade.vue?vue&type=script&setup=true&lang=js"
export * from "./trade.vue?vue&type=script&setup=true&lang=js"

import "./trade.vue?vue&type=style&index=0&id=3c855561&lang=less&scoped=true"

import exportComponent from "D:\\liang_front_end\\payment-system-admin-yuyooke\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c855561"]])

export default __exports__